export default __webpack_public_path__ + "static/media/Icon=Target.d6ac0f18.svg";